import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { AppConstants } from '../app.constants';
import { CustomSnackbarComponent } from '../core/customcomponent/custom-snackbar.component';
import { SuccessSnackbarComponent } from '../core/customcomponent/success-snackbar.component';

@Injectable({
  providedIn: 'root'
})

export class SnackBarService {
  center: MatSnackBarHorizontalPosition = 'center';
  top: MatSnackBarVerticalPosition = 'top';
  snackBarMessage: string;
  isUndoAvailble: boolean = false;

  constructor(private snackBar: MatSnackBar) { }

  showSuccess(message: string, UndoAvailabilty?: boolean) {
    this.snackBarMessage = message;
    this.isUndoAvailble = UndoAvailabilty;
    const config: MatSnackBarConfig = {
      duration: AppConstants.stayDuration,
      horizontalPosition: this.center,
      panelClass: AppConstants.successMessageClass,
      verticalPosition: this.top
    };
    const snackBarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, config);
  }

  showError(message: string) {
    this.snackBarMessage = message;
    const config: MatSnackBarConfig = {
      horizontalPosition: this.center ,
      panelClass: AppConstants.errorMessageClass,
      verticalPosition: this.top,
      duration: 10000
    };
    
    const snackBarRef = this.snackBar.openFromComponent(CustomSnackbarComponent, config);
  }
}
